import { render, staticRenderFns } from "./SupportLayout.vue?vue&type=template&id=024a11c5&scoped=true"
import script from "./SupportLayout.vue?vue&type=script&lang=js"
export * from "./SupportLayout.vue?vue&type=script&lang=js"
import style0 from "./SupportLayout.vue?vue&type=style&index=0&id=024a11c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_webpack@5.98.0__lodash@4.17.21_prettier@3.5.3_react@17.0.2_webpack@5.98.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024a11c5",
  null
  
)

export default component.exports